import { isNullOrUndefinedOrEmpty } from "../filter-value";

const ERROR_MSG = "Please provide a value for all fields highlighted above.";

export const validateExceptionRequest = (data, setError) => {
	if (isNullOrUndefinedOrEmpty(data.exceptionType)) {
		setError(ERROR_MSG);
		return false;
	}

	if (!data.description || data.description.trim().length < 20) {
		setError("Description must be at least 20 characters.");
		return false;
	}

	if (!data.compensatingFactors || data.compensatingFactors.trim().length < 20) {
		setError("Compensating factors must be at least 20 characters.");
		return false;
	}

	setError("");
	return true;
};
